export enum DocumentReviewStatusTypes
{
    PendingReview = 1,
    ReviewCompleted = 2
}

export enum PrivilegeType {
    None = 0,
    Read = 1,               // Read
    ReadUpdate = 2,         // Read & Update existing item
    ReadUpdateWrite = 3     // Read & Update existing item & Write/Insert new item
}

// Maps to:
//      cw_lookup.dbo.security_screens.screen_Id
//      (AND ideally??, <client_database>.dbo.security_screens.window_id)
export enum AppScreens {
    PatientSetup = "NewPatient",
    ImageList = "ImageList",         // Image listing.  For Patients & Orders
    PdfSplit = "PdfSplit",
    SoapNotesListing = "SoapNotesListing",
    NewPaymentBatch = "NewPaymentBatch",
    PaymentBatchDetail = "PaymentBatchDetail",
    CloseAllPaymentBatch = "CloseAllPaymentBatch",
    CloseUserPaymentBatch = "CloseUserPaymentBatch",
    ReOpenPaymentBatch = "ReOpenPaymentBatch",
    ReAssignPaymentBatch = "ReAssignPaymentBatch",
    UpdatePaymentBatch = "UpdatePaymentBatch",
    DocumentScan = "DocumentScan",
    Documents = "Documents",
    DepositNew = "DepositNew2",
    Logging = "Logging",
    Deposit = "Deposit2",
    ReceiptDetails = "ReceiptDetails",
    Receipt = "Receipt",
    PatientCostEstimator = "PatientCostEstimator",
    CommentScreen = "CommentScreen",
    DefaultComments = "CommentDefault",
    BillerAction = "RefTable155",
    User2FA = "user2fa",
    PatientEligibility = "PatientEligibility",
    IdMeVerify = "IDmeVerify",
    IdmeApprove = "IdmeApprove",
    IdMeSign = "iCert5",
    DocumentReconciliation = "DocumentReconciliation",
    RecallSearch = "RecallSearch",
    RecallSetup = "RecallSetup",
    UnsolicitedDocumentSetup = "UnsolicitedDocumentSetup",
    ChoiceAudit = "ChoiceAudit",
    CreditRules = "credt",
    EHIExport = "EHIExport",
    EHIPracticeExport = "EHIPracticeExport",
    PatientFlagSetup = "PatientFlagSetup",
    PatientFlagAssign = "PatientFlagAssign",
    MMLAdmin = "MMLKey",
    PatientHeaderSetup = "PatientHeaderSetup",
    PaymentPlanRules="pplan",
    PaymentPlan="PaymentPlan",
    CheckInOutDashboard="CheckInOutDashboard",
    CheckInOutDashboardShared="CheckInOutDashboardShared",
    TransactionHistory="TransHistory",
    PatientCommunications="PatientCommunication",
    PatientAppointments="AppointmentPatient",
    TemplateEntity="TemplateEntity",
    IntakeAssignment="IntakeAssign",
    AppointmentAudit="AppointmentAudit",
    StatementDetails="StatementDetails",
    PrintSuperbill="PrintableSuperBill",
    PrimaryInsuranceCard="PrimaryInsCard",
    SecondaryInsuranceCard="SecondaryInsCard",
    EMRPortal="EMRPortal",
    BillPortal="BillPortal",
    PaymentEntry="PaymentEntry",
    ActiveReport="HTMLReport",
    EMRSuperbill="EMRSuperbill",
    EMRLetters="EMRLetters",
    ChargeEntry="ChargeEntry",
    Authorization="authorization",
    EMROrderSearch="EMROrderSearch",
    EMRRx = "EMRRx",
    HeadshotCapture = "HeadshotCapture",
    PDFWindow = "PDFWindow",
    EReceiptCommunication = "EReceiptCommunication",
    DSIFeedback = "DSIFeedback",
    CreditClaimSelect = "CreditClaimSelect",
    ReceiptReversal = "ReceiptReversal",
    CoverMyMedsEPA = "cmmepa",
    PatientCareTeam = "PatientCareTeam",
    SurescriptsRecordLocatorInterfaceSetup = "SurescriptsRecordLocatorInterfaceSetup",
    ImportLabResultsHL7File = "ImportLabResultsHL7File"
}

// Maps to: [cw_lookup].[security_screens].[screen_name]
//  Screen name is used to access the user privilege
export enum AppScreenNames {
    ToDoDocReview = "ToDoDocReview.asp",
    User2FA = "User2FA.htm",
    DocumentReconciliation = "DocumentReconciliation",
    UnsolicitedDocumentSetup = "UnsolicitedDocumentSetup",
    CoverMyMedsEpaQueue = "CoverMyMedsEpaQueue", // CoverMyMeds Electronic Prior Auth task Queue
    MMLAdmin = "MMLKey.htm",
    CommentScreen = "CommentScreen.asp",
    PatientPortal_Miscellaneous = "PatientPortal_DemographicsII.img"
}

export enum PayerMixReportDateType {
    ServiceDate = 1,
    ServicePostDate = 2,
    DepositDate = 3,
    DepositPostDate = 4
}

// Value: service_location.location_type 
export enum ServiceLocationType {
    Facility = "FA",
    IndependentLab = "LI"
}

export enum InsuranceType {
    Primary = "primary_insurance",
    Secondary = "secondary_insurance",
    Tertiary = "tertiary_insurance"
}

export enum GenderType {
    Female = "F",
    Male = "M",
    Unknown = "U"       // Unspecified
}

export enum PdfBuilderLocation {
    faxInbox = "inbox",
    faxSent = "sent"
}

export enum MenuNameType {
    Practice = 0,
    Patient = 1,
    Resource = 2,
    Payer = 3
}
export enum SoapNotesType {
    Open = "open",
    Missing = "missing"
}
export enum ResponseStatus {
    Unknown,
    Ok,
    Exception,
    SystemGloballyDownForMaintenance,
    DatabaseDownForMaintenance,
    DatabaseInactive,
    InvalidCredentails
}

export enum ListNames {
    Empty = "Empty",
    ReviewedBy = "ReviewedBy",
    ReviewedByFavorites = "ReviewedByFavorites",
    MailFavorites = "MailFavorites"
}

export enum IntakeFilterOption {
    Always = 1,
    Interval = 2,
    Date = 3
}

export enum Priority {
    Low = 1,
    Normal = 2,
    High = 3
}
export enum Alignment {
    left = "left",
    right = "right",
    center = "center"
}
export enum CompanySettingParameterNames {
    PatientCostEstimator = "ESTM",
    Billing = "Bill",
    BillingReport = "BRPT",
    EMRTabs = "TE_NM",
    Scheduler = "SCHED",
    MyMedicalLocker = "MYMED",
    ServiceLocationReq = "SLREQ"
}

export enum CCDABuildLocation {
    MML = 1,
    FHIR = 2,
    CaseReport = 3
}

export enum CCDABuildStatus {
    NewRecord = 0,
    Built = 1,
    Sent = 2,
    Processing = 3,
    Completed = 10,
    Failed = 99
}

export enum MMLConnectionType
{
	NotConnected = 0,
	Connected = 1,
	TemporaryConnection = 9,
    OptOut = 99
}

export enum TwoFactorApplicationTypes
{
    OneTimePassword_Google = 1
}

export enum TwoFactorEnforcementType
{
    NotUsed = 1,
    PromptKey = 2,
    RequireKey = 3,
    RequireConfirmation = 4
}

export enum TwoFactorTokenTypes
{
    None = 1,
    Email = 2,
    Text = 3,
    TwoFactorApplication = 4
}

export enum UserGroupType {
    Empty = 0,
    User = 1,
    Group = 2
}

/*
    Updates to DataBaseTypeIds affect:
        SQL Function: DATABASE_ID_TYPE_*
        SQL Function: dbo.id_type_enum_value
        SQL Function: dbo.uf_get_entity_parm_eid_from_database_id
        SQL Function: dbo.uf_get_id_type_name
        SQL Table: dbo.database_id_type
        C#: DatabaseIdTypes.cs
        TypeScript: ChoiceEnums.ts			
*/
export enum DatabaseIdTypes {
    INVALID = 0,
    //User
    user_id = 1000,
    user_group_id = 1001,
    security_users_id = 1002,
    security_users_entity_id = 1003, 
    //Resource
    resource_id = 1100,
    resource_category_id = 1101,
    resource_group_id = 1102,
    resource_entity_id = 1103,
    //Service Location
    service_location_id = 1200,
    service_location_entity_id = 1201, 
    //Entity
    entity_id = 1300, 
    //Payer
    payer_id = 1400,
    payer_entity_id = 1401, 
    //Patient
    patient_id = 1500,
    patient_entity_id = 1501,
    appointment_id = 1502,
    receipt_id = 1503,
    //Claim
    claim_id = 1600, 
    // Comments
    comment_id = 1700,
    comment_group_id = 1701,
    default_comment_id = 1702,
    default_comment_group_id = 1703, 
    // Note Types
    ckcc_note = 1801, 
    // Lab
    order_id = 1900,
    lab_requisition_id = 1901, 
    // EMR
    soap_note_id = 2000, 
    // Documents
    image_id = 2100,  
    ccd_id = 2101,
    // CoverMyMeds
    cmm_epa_send_id = 2200,
    cmm_epa_callback_id = 2201, 
    // Providers
    billing_provider_id = 2300,
    provider_entity_id = 2301,
    // Prescription
    prescription_id = 2400,
    // Portals
    portal_none = 2500,
    portal_emr = 2501,
    portal_billing = 2502,
    portal_scheduler = 2503,
    portal_documents = 2504,
    // Pdf Report
    pdf_report_id = 2600,
    pdf_report_key = 2601,
    pdf_report_key_id = 2602,
    // CCDA or CCD
    patient_ccda_record_id = 2700
}

export enum CommentTypes
{
    User = 1,
    System = 2
}

// Maps to [default_comment_group].constant_default_comment_group_id table column
export enum ConstantDefaultCommentGroupsTypes
{
    Patient	= 1,
    ClaimCharge	= 2,
    Payment	= 3,
    Deposit	= 4,
    AppointmentComment = 5,
    AppointmentComplaint =6,
    CancelledAppointment = 7,
    OrderInstructions = 8,
    OrderComments = 9
}

export enum UserSettingGroup
{
    AllTaskReviewSettings = 'ALLRR',
    BillingGadgets = 'BGDT',
    BillingQueryScreendefault = 'BQ0',
    BillingQuery = 'BQ1',
    ClaimCreditSettings = 'CCRDT',
    ClinicalSummarySettings = 'CDACS',
    CoverMyMedsSettings = 'CMM',
    CommentEditorSettings = 'CMTED',
    ContactSettings = 'CNTCT',
    ControlSettings = 'CNTRL',
    CodeSearchSettings = 'CODES',
    CommunicationSettings = 'COMM',
    ClaimProblemDisplay = 'CP1',
    ClaimRuleDisplay = 'CP2',
    DepositSettings = 'DEPST',
    DialysisVisitSettings = 'DIAL',
    DocumentSettings = 'DOCS',
    DocumentReviewSettings = 'DOCSR',
    EMRDocumentPreviewSettings = 'EDOCS',
    eDocuments = 'EDOCV',
    PatientEligibility = 'Elig',
    EMCodingSettings = 'EM',
    Email = 'EMAIL',
    EMR = 'EMR',
    EMRAllergySettings = 'EMRAL',
    EMRPatientDashboard = 'EMRDS',
    EMRProblemSettings = 'EMRPR',
    EMRSchedule = 'EMRSC',
    EMRPortalSetupSettings = 'EMRSS',
    EMRTimelineSettings = 'EMRTM',
    EMRPortalChartTabSettings = 'EMRTS',
    FaxSettings = 'FAX',
    AdvancedFormsFontColor = 'FCOLR',
    AdvancedFormsFontFace = 'FFACE',
    AdvancedFormsFontSize = 'FONT',
    AdvancedFormsPrintForm = 'FPRNT',
    HealthExchangeSettings = 'HIE',
    PatientTxHistory = 'HxTx',
    iSchedulerSettings = 'ISCHD',
    MainDashboardGadgetSettings = 'MDASH',
    MainDashboardGadgetScrollerLeftPositions = 'MDASP',
    MainDashboardGadgetSections = 'MDASS',
    MyTasksSuperbill = 'MTSKC',
    MyTasksEDocuments = 'MTSKD',
    MyTasksOrders = 'MTSKO',
    MyTasksSoapNotes = 'MTSKS',
    MyFaxSettings = 'MYFAX',
    OrderProcessing = 'ORDPR',
    OrderResults = 'ORDRE',
    OrderSpecimenCollection = 'ORDSC',
    OrderWorklist = 'ORDWL',
    OfficeMobileAllergysettings = 'PADAL',
    OfficeMobileEMRsettings = 'PADER',
    OfficeMobileGeneralsettings = 'PADGN',
    OfficeMobileHomesettings = 'PADHM',
    OfficeMobileProblemListsettings = 'PADPR',
    OfficeMobileSummarysettings = 'PADSM',
    PatientPortalToDoSettings = 'PATPR',
    PopulationHealthSettings2 = 'POPH2',
    PopulationHealthSettings = 'POPHL',
    AdvancedFormsDefaultPrinter = 'PRN',
    EMRProblemListSetup = 'PRSET',
    PatientSearch = 'PTSCH',
    QuickAccessMenu = 'QMENU',
    QuickPickExpressions = 'QPICK',
    RoomTracking = 'ROOM',
    RoundSettings = 'ROUND',
    RxDefaultStatus = 'rsSTC',
    RxAlertText = 'rxAT',
    RxDefaultDAW = 'rxDAW',
    RXDefaultFavorite = 'rxDF',
    RxHistoryStatus = 'rxDS',
    PrescriptionDrugSearchParameters = 'rxEx',
    PatientReportedDrugSearchParameters = 'rxExp',
    RxFavoriteDefaultLink = 'rxFD',
    RxOralCode = 'rxOrl',
    RxRefillSettings = 'RXRFR',
    RxReport = 'rxRPT',
    RxRefillSummarySettings = 'RXSUM',
    ScreenUserSettings = 'ScrUS',
    SetupNewSettings = 'SNew',
    SOAPNotes = 'SOAP',
    SOAPReviewSettings = 'SOAPR',
    SupervisingPhysician = 'SPHYS',
    SearchDefaults = 'SRCH',
    SetupSaveSettings = 'SSave',
    StatementSettings = 'STMT',
    SuperbillSettings = 'SUPRB',
    SuperbillReviewSettings = 'SUPRR',
    TicklerSettings = 'TCKLR',
    TestSettings = 'TEST',
    TimeSettings = 'TIME',
    TimelineSettings = 'TLINE',
    TodayHistorySettings = 'TODAY',
    //SearchCheckBoxes,therewillbenoentity_parm_group_codevalues(SeeTSRCH) = 'TSCB',
    SearchOpen_AlwaysOpenAsPopoutWindow = 'TSPO',
    SearchSettings = 'TSRCH',
    SearchSection_Expand_Collapse = 'TSSS',
    UserDashboard = 'UDASH',
    UserLanguage = 'ULAN',
    PatientHeader = 'PTHDR',
}

export enum MessageChannelName {
    PatientCostEstimator = 'PatientCostEstimator',
    CommentsEditor = 'CommentsEditor',
    UnsolicitedDocument = 'UnsolicitedDocument',
    Receipt = 'Receipt',
    PatientPortal_MiscellaneousScreen='PatientPortal_MiscellaneousScreen',
    ReportsLanding = 'ReportsLanding',
    PatientEligibility = 'PatientEligibility',
}

export enum TwoFactorTokenMode
{
    None = "N",
    Email = "E",
    Text = "T",
    IdenTrust = "I",
    TwoFactorApp = "2"      // This option maybe shouldn't be in this enum.  We don't actually issue tokens with 2FA applications
}

export enum EnvironmentType
{
    Dev = "Dev",
    QA = "QA",
    Production = "Prod"
}

export enum DateTimeFormatTypes
{
    AMPM = 1,
    AMPM_Time = 2,
    AMPM_Time_Sec = 3,
    TwentyFour = 4,
    CCD = 5,
    CCD_Month = 6,
    HL7_Date = 7,
    HL7_Time = 8,
    HL7_Time_Sec = 9,
    HL7_Time_Sec_UTC = 10,
    HL7_Time_Sec_UTC_Off = 11,
    Highstock = 12,
    Period = 13,
    Long = 14,
    LongTime = 15,
    Short = 16,
    CCD_Time = 17,
    EDME = 18,
    DayMonthDayYearTime = 19
}

export enum LegacyWindowActions
{
    New = "new",
    Save = "save"
}

export enum PatientSetupTabs
{
    Summary = "Summary",    
    Demographics = "Demographics",
    Insurance = "Insurance",
    ResponsibleParty = "Responsible Party",
    EmergencyContact = "Emergency Contact",
    CaseManagement = "Case Management",
    Comments = "Comments",
    Dialysis = "Dialysis",
    MMLSelfSchedule = "MML Self Schedule",
    SlidingFee = "Sliding Fee",
    ImmunRegistry = "Immun. Registry",
    Discharge = "Discharge",
    Miscellaneous = "Miscellaneous",
    ReferralTracking = "Referral Tracking"
}

export enum ShortcutKeyCodes
{
    A = "KeyA",
    B = "KeyB",
    C = "KeyC",
    D = "KeyD",
    E = "KeyE",
    F = "KeyF",
    G = "KeyG",
    H = "KeyH",
    I = "KeyI",
    J = "KeyJ",
    K = "KeyK",
    L = "KeyL",
    M = "KeyM",
    N = "KeyN",
    O = "KeyO",
    P = "KeyP",
    Q = "KeyQ",
    R = "KeyR",
    S = "KeyS",
    T = "KeyT",
    U = "KeyU",
    V = "KeyV",
    W = "KeyW",
    X = "KeyX",
    Y = "KeyY",
    Z = "KeyZ",
    Zero = "Digit0",
    One = "Digit1",
    Two = "Digit2",
    Three = "Digit3",
    Four = "Digit4",
    Five = "Digit5",
    Six = "Digit6",
    Seven = "Digit7",
    Eight = "Digit8",
    Nine = "Digit9",
    Escape = "Escape",
    Plus = "NumpadAdd",
    Minus = "NumpadSubtract",
    ArrowUp = "ArrowUp",
    ArrowDown = "ArrowDown"
}

export enum SecurityScreenId
{
    DocumentReconciliation = 1408,
    DocumentTypeSetup = 1393,
    PatientCostEstimator = 1294,
    ToDoDocReview = 425,
    UnsolicitedDocumentSetup = 1412
}

export enum SecurityLoggingType
{
    ConsultPrint = "b",
    ConsultView = "r",
    Export = "e",
    Fax = "m",
    Insert = "i",
    LogView = "l",
    MeaningfulUse = "u",
    Modified = "s",
    Print = "p",
    Search = "f",
    Signoffy = "y",
    Signoffz = "z",
    UndoSignoff = "x",
    View = "g"
}

// A company database product type
export enum ProductType
{
    Updox = 48,
    FHIR = 51,
    UpdoxReminders = 53,
    IdMeEpcs = 54,
    PerformanceAudit = 57,  // Degraded API Performance Auditing
    SpeechToText = 58,
}

// A company database feature type
export enum FeatureType
{
    Institutional_837 = '837 Institutional',
    AllAccess = 'All Access',
    Allergies_New = 'Allergies (new)',
    AllowedAmountAging = 'Allowed Amount Aging',
    Assessment_new = 'Assessment (new)',
    CCDExportSchedule = 'CCD Export Schedule',
    CCMCarePlan = 'CCMCarePlan',
    CheckInOutDashboard = 'Check In/Out Dashboard',
    DataExport = 'Data Export',
    DemographicBridge = 'Demographic Bridge',
    Dialysis = 'Dialysis',
    DOCS4DOCS = 'DOCS4DOCS',
    eDME = 'eDME',
    ElectronicStatements = 'Electronic Statements',
    EMCoding = 'EM Coding',
    EstimateApproval = 'Estimate Approval',
    Exams_new = 'Exams (new)',
    FakeRx = 'Fake Rx',
    Faxing = 'Faxing',
    History_new = 'History (new)',
    HPI_new = 'HPI (new)',
    InfoDive = 'InfoDive',
    MMLConnectionExtended = 'MML Connection Extended',
    ONCRxTesting = 'ONC Rx Testing',
    Orders = 'Orders',
    PatientExport = 'Patient Export',
    PatientPortal = 'Patient Portal',
    PaymentPlan = 'Payment Plan',
    PaySimple = 'PaySimple',
    PDFSplit = 'PDF Split',
    ReceiveElectronic835 = 'Receive Electronic 835',
    ResultsTasking = 'Results Tasking',
    ROS_new = 'ROS (new)',
    RxRefill = 'RxRefill',
    SalesImport = 'Sales Import',
    SecureExchangeSolutionsEDGEDIRECTConnectivity = 'Secure Exchange Solutions EDGE DIRECT Connectivity',
    ShowPageError = 'ShowPageError',
    StatementBuild = 'Statement Build',
    SunRx = 'SunRx',
    SureScriptsRecordLocator = 'SureScripts Record Locator',
    Transcription = 'Transcription',
    TreatmentPlans_new = 'Treatment Plans (new)',
    ZynxEvidence = 'Zynx Evidence'
}

export enum PhoneType
{
    Home,
    Work,
    Fax,
    Other
}

export enum PhoneReminderType
{
    Home = "H",
    Work = "W",
    Other = "O",
    Override = "Z"
}

export enum EmailReminderType
{
    Patient = "P",
    Override = "Z"
}


export enum BrowserType
{
    Opera = "Opera",
    MSIE = "Microsoft Internet Explorer",
    Edge = "Edge",
    Chrome = "Chrome",
    Safari = "Safari",
    Firefox = "Firefox",
    Trident = "Trident",
    Other = "Other"
}

export enum CKCCStatusType
{
    NotUsed = 0,
	ProgramExistButPatientNotEnrolled = 1,
    PatientEnrolled = 2
}

export enum ContactType
{
    Provider = 1,
    Payer = 2,
    ServiceLocation = 3,
    Custom = 4
}

export enum MdrCcmStatusType
{
    Enrolled ="E",
    Unknown = "U", 
    Disenrolled = "D", 
    OptedOut = "O"
}

export enum MdrRpmStatusType
{
    Enrolled ="E",
    Unknown = "U", 
    Disenrolled = "D", 
    OptedOut = "O"
}

export enum PortalType
{
    Emr = 2501,
    Billing = 2502,
    Scheduler = 2503,
    Documents = 2504
}

export enum CKCCStatus
{
    NoStatus = 0,
    Unknown = 1,
    Enrolled = 2,
    Disenrolled = 3,
    OptedOut = 4,
    Deceased = 5    
}

export enum EligibilityCoverage
{
    Inactive = 0,
    Active = 1,
    NeedsReview = 2,
    PayerDoesNotPerformElig = 3
}

export enum PaymentReceiptPreference_ReceiptCommunication
{
    TextMessageHome = 1,
    TextMessageWork = 2,
    TextMessageOther = 3,
    Email = 4,
    TextOverride = 5,
    EmailOverride = 6

}

export enum HealthInformationExchange_ConsentType
{
    Unknown = "U",
    Granted = "G",
    Denied = "D"
}

export enum EnrolementStatusType
{
    Unknown = "U",
    Enrolled = "E",
    DisEnrolled = "D",
    OptedOut = "O",
    Deceased = "X"
}

export enum MiscScreenSectionId
{
	NYPreschoolBilling = 1,
	ChronicCareManagement = 2,
	AppointmentReminders = 3,
	OptimizeRx = 4,
	PrescriptionEducation = 5,
	HealthInformationExchange = 6,
	MDRevolutionStatus = 7,
	CKCCStatus = 8,
	PaymentReceiptPreference = 9,
	RecordLocatorConsent = 10
}

export enum CreditCardFraudIndicator
{
    NotFraudulent = 0,
    IsFraudulent = 1
}

export enum AppointmentState
{
    New = 0,
    Edit = 2
}

export enum CreateAppointmentResultType
{
    RestrictedOperation = 0,
    Success = 1
}

